/* ==========================================================================
   Kopstorm CRO Suite - Wave 4 behaviour
   W50 interactive info layer · W51 card explainer · W53 photo chip
   W54 read more toggle · preview toolbar

   W49/W49b and W52 are pure Liquid + CSS and need no JavaScript.

   Everything here is additive and idempotent. Features watch the html flag
   classes, so Intelligems can enable a test mid session and the layer wakes
   up without a reload. All copy comes from window.KopstormW4.copy, which the
   flag snippet fills from the locale files. Tokens use the [count] square
   bracket shape, never curly braces.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var W4 = window.KopstormW4 || {};
  var copy = W4.copy || {};
  var conf = W4.settings || {};

  function t(key, fallback) {
    var value = copy[key];
    return typeof value === 'string' && value !== '' ? value : fallback;
  }
  function has(flag) { return root.classList.contains('kop-' + flag); }
  function on(flag) { return has(flag) || has('w4editor') || has('w4preview'); }

  /* ------------------------------------------------------------------
     Shared popover (W50 + W51)
     ------------------------------------------------------------------ */
  var pop = doc.querySelector('[data-kop4-pop]');
  var popTitle = pop && pop.querySelector('[data-kop4-pop-title]');
  var popBody = pop && pop.querySelector('[data-kop4-pop-body]');
  var popAnchor = null;

  function closePop() {
    if (!pop) return;
    pop.classList.remove('kop4-pop--open');
    pop.setAttribute('aria-hidden', 'true');
    popAnchor = null;
  }

  function openPop(anchor, title, bodyHtml) {
    if (!pop || !anchor) return;
    if (popAnchor === anchor && pop.classList.contains('kop4-pop--open')) {
      closePop();
      return;
    }
    popTitle.textContent = title || '';
    popBody.innerHTML = bodyHtml || '';
    pop.setAttribute('aria-hidden', 'false');
    pop.classList.add('kop4-pop--open');
    popAnchor = anchor;
    positionPop(anchor);
  }

  function positionPop(anchor) {
    var rect = anchor.getBoundingClientRect();
    var width = pop.offsetWidth;
    var height = pop.offsetHeight;
    var gap = 8;
    var left = Math.round(rect.left + rect.width / 2 - width / 2);
    left = Math.max(12, Math.min(left, window.innerWidth - width - 12));
    var top = Math.round(rect.bottom + gap);
    if (top + height > window.innerHeight - 12) {
      top = Math.max(12, Math.round(rect.top - height - gap));
    }
    pop.style.left = left + 'px';
    pop.style.top = top + 'px';
  }

  if (pop) {
    pop.addEventListener('click', function (event) {
      if (event.target.closest('[data-kop4-pop-close]')) closePop();
    });
    doc.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePop();
    });
    window.addEventListener('scroll', function () {
      if (popAnchor) positionPop(popAnchor);
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (popAnchor) positionPop(popAnchor);
    });
  }

  /* Shared with Wave 5, which reuses this popover for the W58 chips rather
     than shipping a second host. */
  window.KopstormPop = { open: openPop, close: closePop };

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function para(text) { return '<p>' + esc(text) + '</p>'; }

  /* ------------------------------------------------------------------
     W50 · interactive info layer on the PDP dead click elements
     ------------------------------------------------------------------ */
  function badgeInfo(badge) {
    if (badge.classList.contains('badge--onsale')) {
      return { title: t('save_title', 'Your saving'), body: para(t('save_text', '')) };
    }
    var label = (badge.textContent || '').toLowerCase();
    if (label.indexOf('best') !== -1) {
      return { title: t('bestseller_title', 'Bestseller'), body: para(t('bestseller_text', '')) };
    }
    if (label.indexOf('coming') !== -1 || label.indexOf('soon') !== -1) {
      return { title: t('soon_title', 'Coming soon'), body: para(t('soon_text', '')) };
    }
    if (label.indexOf('new') !== -1) {
      return { title: t('new_title', 'New'), body: para(t('new_text', '')) };
    }
    if (label.indexOf('%') !== -1 || label.indexOf('save') !== -1 || label.indexOf('-') === 0) {
      return { title: t('save_title', 'Your saving'), body: para(t('save_text', '')) };
    }
    return null;
  }

  function reviewsTarget() {
    return doc.getElementById('looxReviews')
      || doc.querySelector('#shopify-block-loox_reviews_loox_dynamic_section, [id*="looxReviews"]')
      || doc.querySelector('.loox-snippets-widget, [class*="loox-snippets"], [data-loox]');
  }

  var w50Marked = false;
  function markW50() {
    if (!doc.querySelector('.product-info, product-info, .product__info, [data-product-info]') && !doc.querySelector('.product__offer-callout')) return;
    /* Affordance classes; harmless to re-run */
    doc.querySelectorAll('.product__offer-callout').forEach(function (el) {
      el.classList.add('kop4-can-tap');
    });
    doc.querySelectorAll('.badges').forEach(function (wrap) {
      /* the stock badge row is pointer-events none; only the product page
         badge rows are opted back in, cards stay untouched */
      if (wrap.closest('.product-card')) return;
      wrap.classList.add('kop4-badges-live');
      wrap.querySelectorAll('.badge').forEach(function (badge) {
        if (badgeInfo(badge)) badge.classList.add('kop4-can-tap');
      });
    });
    if (reviewsTarget()) {
      doc.querySelectorAll('.rating, [class*="loox-rating"]').forEach(function (el) {
        if (el.closest('.product-card')) return;
        el.classList.add('kop4-rating-link');
        if (!el.hasAttribute('title')) el.setAttribute('title', t('rating_hint', 'Read the reviews'));
      });
    }
    w50Marked = true;
  }

  doc.addEventListener('click', function (event) {
    if (!on('w50')) return;

    var chip = event.target.closest('.product__offer-callout');
    if (chip && !chip.closest('.product-card')) {
      var chipTitle = chip.querySelector('.product__offer-callout-heading');
      openPop(chip, chipTitle ? chipTitle.textContent.trim() : t('gift_title', ''), para(t('gift_text', '')));
      return;
    }

    var badge = event.target.closest('.kop4-badges-live .badge');
    if (badge) {
      var info = badgeInfo(badge);
      if (info) { openPop(badge, info.title, info.body); return; }
    }

    var rating = event.target.closest('.kop4-rating-link');
    if (rating && !event.target.closest('a')) {
      var target = reviewsTarget();
      if (target) {
        closePop();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    if (!event.target.closest('[data-kop4-pop]')) closePop();
  });

  /* ------------------------------------------------------------------
     W51 · difficulty and piece count explainer on collection cards
     ------------------------------------------------------------------ */
  var TIERS = ['beginner', 'intermediate', 'advanced'];

  function tierBody(activeTier) {
    var rows = TIERS.map(function (tier) {
      var line = t('tier_' + tier, tier);
      var active = tier === activeTier ? ' kop4-pop__tier--active' : '';
      return '<span class="kop4-pop__tier' + active + '">'
        + '<span class="kop4-pop__tier-dot"></span><span>' + esc(line) + '</span></span>';
    });
    return rows.join('');
  }

  doc.addEventListener('click', function (event) {
    if (!on('w51')) return;
    var cell = event.target.closest('.product-card__icon');
    if (!cell) return;
    var label = (cell.textContent || '').trim().toLowerCase();
    var matchedTier = null;
    TIERS.forEach(function (tier) {
      if (label.indexOf(tier) !== -1) matchedTier = tier;
    });
    if (matchedTier) {
      event.preventDefault();
      openPop(cell, t('tier_title', 'Difficulty levels'), tierBody(matchedTier));
      return;
    }
    if (/piece|pieces|stukjes|onderdelen|teile|pi[eè]ces|piezas|pezzi/.test(label) || /^\d/.test(label)) {
      event.preventDefault();
      openPop(cell, t('pieces_title', 'Piece count'), para(t('pieces_text', '')));
    }
  });

  var w51Marked = false;
  function markW51() {
    doc.querySelectorAll('.product-card__icon').forEach(function (cell) {
      cell.classList.add('kop4-can-tap');
    });
    w51Marked = true;
  }

  /* ------------------------------------------------------------------
     W53 · "View all photos" chip on the product gallery
     ------------------------------------------------------------------ */
  function buildPhotoChips() {
    doc.querySelectorAll('media-gallery, [id^="MediaGallery"], .product__media-gallery').forEach(function (gallery) {
      if (gallery.querySelector('[data-kop4-photos]')) return;
      var buttons = gallery.querySelectorAll('[is="media-lightbox-button"]');
      if (!buttons.length) return;
      var firstButton = buttons[0];
      var host = firstButton.parentElement;
      if (!host) return;
      var count = buttons.length;
      var label = t('view_all', 'View all [count] photos').replace(/\[count\]/gi, String(count));
      var chip = doc.createElement('button');
      chip.type = 'button';
      chip.className = 'kop4-photos';
      chip.setAttribute('data-kop4-photos', '');
      chip.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">'
        + '<path d="M3 5h18v14H3zM3 15l5-5 4 4 3-3 6 6M9 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" '
        + 'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '<span>' + esc(label) + '</span>';
      chip.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        /* prefer the lightbox button of the slide currently in view */
        var active = gallery.querySelector('.is-active [is="media-lightbox-button"], [aria-current] [is="media-lightbox-button"]') || firstButton;
        active.click();
      });
      host.classList.add('kop4-media-host');
      host.appendChild(chip);
    });
  }

  /* ------------------------------------------------------------------
     W54 · compact collection description with Read more
     ------------------------------------------------------------------ */
  function initW54() {
    doc.querySelectorAll('.collection__description').forEach(function (description) {
      if (description.dataset.kop4W54) return;
      description.dataset.kop4W54 = '1';
      var lines = parseInt(conf.w54_lines, 10);
      if (!lines || lines < 1) lines = 2;
      description.style.setProperty('--kop4-w54-lines', String(lines));
      description.classList.add('kop4-w54-clamp');

      var toggle = doc.createElement('button');
      toggle.type = 'button';
      toggle.className = 'kop4-w54-toggle';
      toggle.textContent = t('read_more', 'Read more');
      description.insertAdjacentElement('afterend', toggle);

      function sync() {
        var clamped = description.classList.contains('kop4-w54-clamp');
        var overflowing = description.scrollHeight > description.clientHeight + 2;
        toggle.classList.toggle('kop4-w54-toggle--show', overflowing || !clamped);
      }
      toggle.addEventListener('click', function () {
        var clamped = description.classList.toggle('kop4-w54-clamp');
        toggle.textContent = clamped ? t('read_more', 'Read more') : t('read_less', 'Read less');
        sync();
      });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ------------------------------------------------------------------
     Wake up per flag, now and whenever a flag flips
     ------------------------------------------------------------------ */
  function refresh() {
    if (on('w50') && !w50Marked) markW50();
    if (on('w51') && !w51Marked) markW51();
    if (on('w53')) buildPhotoChips();
    if (on('w54')) initW54();
    if (!on('w50') && !on('w51')) closePop();
  }

  doc.addEventListener('kopstorm:flag', refresh);
  /* the facet form replaces the collection grid, so re mark the new cards */
  if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && typeof theme.pubsub.subscribe === 'function') {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, function () {
      w51Marked = false;
      window.setTimeout(refresh, 0);
    });
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  /* ------------------------------------------------------------------
     Preview toolbar (kop_w4_preview only)
     ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------
     W53 · thumbnail strip inside the PhotoSwipe lightbox
     ------------------------------------------------------------------
     Ships with the same flag as the View all photos chip, so the two
     activate together. The theme's lightbox is PhotoSwipe v5, created
     lazily on the media-gallery element and rebuilt on every open, with
     the pswp module loaded async. So: on any lightbox-opening click we
     poll briefly for the live pswp instance, then append one strip of
     the gallery's own slide images to the pswp root. Tapping a thumb
     calls pswp.goTo; the active thumb tracks pswp's change event and the
     strip dies with the pswp root on close, so there is nothing to
     clean up.
     ------------------------------------------------------------------ */
  function kop4LightboxThumbs() {
    var mg = doc.querySelector('media-gallery');
    var lb = mg && mg._photoswipe;
    var pswp = lb && lb.pswp;
    if (!pswp || !pswp.element) return false;
    if (pswp.element.querySelector('[data-kop4-lbthumbs]')) return true;

    var gallery = mg.closest('.product__media-container') || mg;
    var buttons = gallery.querySelectorAll('[is="media-lightbox-button"]');
    if (buttons.length < 2) return true;

    var strip = doc.createElement('div');
    strip.className = 'kop4-lbthumbs';
    strip.setAttribute('data-kop4-lbthumbs', '');

    Array.prototype.forEach.call(buttons, function (button, index) {
      var slide = button.closest('.product__media') || button.parentElement;
      var img = slide ? slide.querySelector('img') : null;
      var item = doc.createElement('button');
      item.type = 'button';
      item.className = 'kop4-lbthumbs__item';
      item.setAttribute('aria-label', String(index + 1));
      if (img && (img.currentSrc || img.src)) {
        var thumb = doc.createElement('img');
        thumb.src = img.currentSrc || img.src;
        thumb.alt = '';
        thumb.loading = 'lazy';
        item.appendChild(thumb);
      } else {
        /* video or 3D slide without a poster image: show a play glyph */
        item.classList.add('kop4-lbthumbs__item--media');
        item.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';
      }
      item.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (lb.pswp) lb.pswp.goTo(index);
      });
      strip.appendChild(item);
    });

    function sync() {
      if (!lb.pswp) return;
      var current = lb.pswp.currIndex;
      Array.prototype.forEach.call(strip.children, function (el, i) {
        var active = i === current;
        el.classList.toggle('is-active', active);
        if (active && el.scrollIntoView) el.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    }
    pswp.on('change', sync);
    pswp.element.appendChild(strip);
    sync();
    return true;
  }
  doc.addEventListener('click', function (event) {
    if (!on('w53')) return;
    var opener = event.target.closest('[is="media-lightbox-button"], [data-kop4-photos]');
    if (!opener) return;
    var tries = 0;
    (function poll() {
      if (kop4LightboxThumbs() || tries++ > 25) return;
      setTimeout(poll, 120);
    })();
  }, true);

  var toolbar = doc.querySelector('[data-kop4-toolbar]');
  if (toolbar) {
    var registry = [
      { id: 'w49', label: 'W49 Offer stack, reward framing' },
      { id: 'w49b', label: 'W49b Offer stack, offer framing' },
      { id: 'w50', label: 'W50 PDP info layer' },
      { id: 'w51', label: 'W51 Card spec explainer' },
      { id: 'w52', label: 'W52 Localized strip' },
      { id: 'w53', label: 'W53 View all photos chip' },
      { id: 'w54', label: 'W54 Compact collection intro' }
    ];
    var handle = toolbar.querySelector('[data-kop4-toolbar-handle]');
    var panel = toolbar.querySelector('[data-kop4-toolbar-panel]');
    var rowsHost = toolbar.querySelector('[data-kop4-toolbar-rows]');
    var countMark = toolbar.querySelector('[data-kop4-toolbar-count]');
    var api = window.KopstormCRO || null;

    function setFlag(id, active) {
      if (api && api.enable && api.disable) {
        if (active) api.enable(id); else api.disable(id);
      } else {
        root.classList.toggle('kop-' + id, active);
      }
      if (id === 'w49' && active) setFlag('w49b', false);
      if (id === 'w49b' && active) setFlag('w49', false);
    }

    function renderRows() {
      rowsHost.innerHTML = '';
      var activeCount = 0;
      registry.forEach(function (test) {
        var active = has(test.id);
        if (active) activeCount += 1;
        var row = doc.createElement('label');
        row.className = 'kop4-toolbar__row';
        var box = doc.createElement('input');
        box.type = 'checkbox';
        box.checked = active;
        box.addEventListener('change', function () {
          setFlag(test.id, box.checked);
          renderRows();
          refresh();
        });
        var text = doc.createElement('span');
        text.textContent = test.label;
        row.appendChild(box);
        row.appendChild(text);
        rowsHost.appendChild(row);
      });
      countMark.textContent = String(activeCount);
    }

    handle.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
      handle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) renderRows();
    });
    toolbar.querySelector('[data-kop4-toolbar-all]').addEventListener('click', function () {
      registry.forEach(function (test) { if (test.id !== 'w49b') setFlag(test.id, true); });
      renderRows();
      refresh();
    });
    toolbar.querySelector('[data-kop4-toolbar-none]').addEventListener('click', function () {
      registry.forEach(function (test) { setFlag(test.id, false); });
      renderRows();
      refresh();
    });
    doc.addEventListener('kopstorm:flag', function () {
      if (!panel.hasAttribute('hidden')) renderRows();
    });
    renderRows();
  }
})();
